import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@nexus/ui";
import { cn } from "@nexus/ui";

interface SuperTenantBadgeProps {
  /** Pixel size of the icon. Defaults to 12 (h-3 w-3). */
  size?: number;
  className?: string;
}

/**
 * Inline marker shown next to a user's name when they belong to a
 * SUPER_TENANT (platform admin). Renders a small primary-tinted shield
 * with a tooltip that explains the privilege.
 *
 * Used across the IAM dashboard wherever a user is rendered:
 * People table, Person drawer header, Org drawer members,
 * Role drawer members.
 */
export function SuperTenantBadge({ size = 12, className }: SuperTenantBadgeProps) {
  const { t } = useTranslation();
  const label = t("iam.superTenant.badge");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          aria-label={label}
          className={cn(
            "inline-flex shrink-0 items-center justify-center text-primary",
            className,
          )}
          style={{ width: size, height: size }}
        >
          <ShieldCheck style={{ width: size, height: size }} aria-hidden />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">{t("iam.superTenant.tooltip")}</TooltipContent>
    </Tooltip>
  );
}
